module.exports = __webpack_public_path__ + "img/PLI-logo.caf2893e.svg";